import styled from "styled-components";
import { useSwiper } from "swiper/react";
import { device } from "../../../constants";

const BulletsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 0;

  @media ${device.laptop} {
    margin-top: 8px;
  }
`;

const Bullet = styled.button`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme, active }) => active ? theme.colors['neutral-07'] : theme.colors['neutral-03']};

  :is([data-theme="dark"] &) {
    background-color: ${({ theme, active }) => active ? theme.colors['neutral-01'] : theme.colors['neutral-03']};
  }
`;

export function SlideBulletNavigation({ activeBullet }) {
  const swiper = useSwiper();

  const bullets = Array.from({ length: swiper.snapGrid.length }, (_, index) => index);

  return (
    <BulletsContainer className="bullets-container">
      {bullets?.map((bulletIndex) => (
        <Bullet
          className={`${activeBullet === bulletIndex ? 'bullet-active' : ''} bullet`}
          type='button'
          key={bulletIndex}
          active={activeBullet === bulletIndex}
          onClick={() => swiper.slideTo(bulletIndex)}
        ></Bullet>
      ))}
    </BulletsContainer>
  );
}